import { API, graphqlOperation, Storage } from 'aws-amplify';
//import unlayer from '@/util/unlayer-options';

const getPreview = (template) => {
  let t = null;
  if(typeof(template) === 'string') {
    t = JSON.parse(template);
  } else {
    t = template;
  }
  if(!t) {
    return null;
  }
  let p = t.HtmlPart;
  //console.debug('Getting campaign preview...', p);
  p = p.replace(/{{ ?PRODUCT_IMAGE_?C?[a-z0-9-]{0,40}_\d+ ?}}/gi, 'https://placehold.co/200x200/png?text=PRODUCT+IMAGE');
  p = p.replace(/<img src="[\w\d:/.-]+\/pixel\/message\/{{ MESSAGE_ID }}\/pixel.png" alt="">/gi, '<img src="https://placehold.co/1x1/png">');
  return p;
}

const prepareCampaignForSave = (f) => {
  if(f.segment) {
    f.segment = JSON.stringify(f.segment);
  }
  if(f.evaluationPeriod) {
    f.evaluationPeriod = JSON.stringify(f.evaluationPeriod);
  }
  if(f.schedule) {
    f.schedule = JSON.stringify(f.schedule);
  }
  if(f.templateUnlayer) {
    f.templateUnlayer = JSON.stringify(f.templateUnlayer);
  }
  if(f.templateSES) {
    f.templateSES = JSON.stringify(f.templateSES);
  }
  
  if(f.utm?.campaign) {
    f.utm.campaign = encodeURIComponent(f.utm.campaign);
  }
  return f;
}

export default {
    namespaced:true,
    state: {
        entity: 'Campaign',
        list: null,
        item: null,
        preview: null,
        nextToken: null,
        archivedNextToken: null,
        archiveLoaded: null,
        stateOrdering: ['INCOMPLETE', 'WAITING', 'COMPUTING', 'SENDING', 'COMPLETED', 'DISABLED'],
        existingDesigns: null,
        itemStats: null,
        statsCache: {}
    },
    mutations: {
        list: (state, payload) => { state.list = payload.append ? (state.list || []).concat(payload.value) : payload.value },
        item: (state, payload) => { state.item = payload.value },
        preview: (state, payload) => { state.preview = payload.value },
        nextToken: (state, payload) => { state.nextToken = payload.value },
        archivedNextToken: (state, payload) => { state.archivedNextToken = payload.value },
        archiveLoaded: (state, payload) => { state.archiveLoaded = payload.value },
        loadRecipients: (state, payload) => { Object.assign(state.item, payload) },
        existingDesigns: (state, payload) => {state.existingDesigns = payload.append ? (state.existingDesigns || []).concat(payload.value) : payload.value},
        itemStats: (state, payload) => { state.itemStats = payload },
        statsCache: (state, payload) => { state.statsCache[payload.id] = payload },
    },
    getters: {
       listAutomatic: (state) => state.list?.filter(c => c.scheduleType == 'AUTOMATIC'),
       listBtc: (state) => state.list?.filter(c => c.scheduleType == 'BACK_TO_CART'),
       listSwu: (state) => state.list?.filter(c => c.scheduleType == 'SMART_WARM_UP'),
       listWelcome: (state) => state.list?.filter(c => c.scheduleType == 'WELCOME'),
       listScheduled: (state) => state.list?.filter(c => c.scheduleType == 'SCHEDULED').sort((a,b)=> { 
         let r = state.stateOrdering.findIndex(v => v == a.state) - state.stateOrdering.findIndex(v => v == b.state);
         // the same state
         if(!r && (a.schedule?.start == null || a.schedule.start > b.schedule?.start)) {
           r = -1;
         } else if(!r && (b.schedule?.start == null || a.schedule?.start < b.schedule.start)) {
           r = 1;
         }
         // the same schedule
         if(!r) {
           r = a.name.localeCompare(b.name);
         }
         return r;
        }),
        //itemStats: (state) => state.stats[state.item?.id]
    },
    actions: {
        async get(context, payload) {
            const q = await API.graphql(graphqlOperation( /* GraphQL */`
            query GetCampaign($id: ID!) {
              getCampaign(id: $id) {
                id
                domainID
                name
                medium
                state
                from
                friendlyFrom
                replyTo
                scheduleType
                schedule
                segmentationType
                segment
                priority
                force
                
                evaluationPeriod
                utm {
                  source
                  medium
                  campaign
                }
                domain {
                  dnsName
                  currency
                  firstDayOfWeek
                  timezone
                }
                createdAt

                # legacy campaigns
                subjects
                templateSES
                templatePreview
                templateUnlayer
                textVersion
                templateSpecs { ...specs }
                templateSpecsNew { ...specs }
                templateSpecsCategories {
                  productCategoryID
                  specs { ...specs }
                }

                # campaign variants
                variants(limit: 1000) {
                  items {
                      id
                      name
                      subject
                      active
                      # used for summary stats
                      templateSpecs {
                          ...specs
                      }
                      templateSpecsNew {
                          ...specs
                      }
                      templateSpecsCategories {
                          productCategoryID
                          specs {...specs }
                      }
                  }
                }
              }
            }

            fragment specs on TemplateRecommendationsSpecs {
                  recommendationsCount
                  name
                  price
                  image
                  sale
                  description
                  originalPrice
                  stripDescription
                  defaultSale
                  saleTemplate
                  originalPriceTemplate
            }

            `, { id: payload.id }));
            let c = q.data.getCampaign;
            c.segment = JSON.parse(c.segment); 
            c.evaluationPeriod = JSON.parse(c.evaluationPeriod); 
            c.schedule = JSON.parse(c.schedule);
            c.templateUnlayer = JSON.parse(c.templateUnlayer);
            c.templateSES = JSON.parse(c.templateSES);
            c.variants = c.variants.items;
            if(c.utm?.campaign) {
              c.utm.campaign = decodeURIComponent(c.utm.campaign);
            }
            if(!payload.noStore) {
              context.commit('itemStats', null);
              context.commit('item', {value: c });
              context.commit('preview', {value: getPreview(c.templateSES || c.templatePreview) });
            }
            return c;
        },
        
        async list(context, payload) {
          const c = await API.graphql(graphqlOperation(/* GraphQL */`
          query CampaignsByDomainPriority(
            $domainID: ID
            $priority: ModelIntKeyConditionInput
            $sortDirection: ModelSortDirection
            $filter: ModelCampaignFilterInput
            $limit: Int
            $nextToken: String
          ) {
            campaignsByDomainPriority(
              domainID: $domainID
              priority: $priority
              sortDirection: $sortDirection
              filter: $filter
              limit: $limit
              nextToken: $nextToken
            ) {
              items {
                id
                name
                medium
                state
                scheduleType
                schedule
                segmentationType
                segment
                priority
                force
                evaluationPeriod
                subjects # why were they here? Anyway, now it is used to distinguish legacy campaigns
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          `, payload ));
          let campaigns = c.data.campaignsByDomainPriority.items;
          campaigns.forEach(c => { c.segment = JSON.parse(c.segment); c.evaluationPeriod = JSON.parse(c.evaluationPeriod); c.schedule = JSON.parse(c.schedule) });
          context.commit('list', {value: campaigns, append: !!payload?.nextToken });
          context.commit('nextToken', {value: c.data.campaignsByDomainPriority.nextToken });
          if(context.state.nextToken) {
            await context.dispatch('list', { ...payload, nextToken: context.state.nextToken });
          }
        },

        async listArchived(context, payload) {
          context.commit('archiveLoaded', {value: true });
          const c = await API.graphql(graphqlOperation(/* GraphQL */`
          query CampaignsByDomainState(
            $domainID: ID
            $state: String
            $sortDirection: ModelSortDirection
            $filter: ModelCampaignFilterInput
            $limit: Int
            $nextToken: String
          ) {
            campaignsByDomainState(
              domainID: $domainID
              state: { eq: $state } 
              sortDirection: $sortDirection
              filter: $filter
              limit: $limit
              nextToken: $nextToken
            ) {
              items {
                id
                name
                medium
                state
                scheduleType
                schedule
                segmentationType
                segment
                priority
                force
                evaluationPeriod
                subjects # why were they here? Anyway, now it is used to distinguish legacy campaigns
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          `, payload ));
          let campaigns = c.data.campaignsByDomainState.items;
          campaigns.forEach(c => { c.segment = JSON.parse(c.segment); c.evaluationPeriod = JSON.parse(c.evaluationPeriod); c.schedule = JSON.parse(c.schedule) });
          context.commit('list', {value: campaigns, append: true });
          context.commit('archivedNextToken', {value: c.data.campaignsByDomainState.nextToken });
          if(context.state.archivedNextToken) {
            await context.dispatch('listArchived', { ...payload, nextToken: context.state.archivedNextToken });
          }
        },

        async create(context, payload) {
          // get domain object from payload
          /* moved to variant */
          let specs = {
            recommendationsCount: 0,
            name: false,
            price: false,
            image: false,
            sale: false,
            description: false,
            originalPrice: false,
            saleTemplate: '-{}%',
            originalPriceTemplate: '{}',
            defaultSale: payload.domain.defaultSale || 0,
            stripDescription: 0
          }
          
          if(payload.fields.segment) {
            payload.fields.segment = JSON.stringify(payload.fields.segment);
          }
          let input = Object.assign({
            state: 'INCOMPLETE',
            domainID: payload.domain.id,
            //owner: payload.domain.owner, 
            editors: [payload.domain.owner, ...(payload.domain.editors || [])],
            from: payload.domain.from,
            friendlyFrom: payload.domain.friendlyFrom,
            replyTo: payload.domain.replyTo,
            utm: {
              source: 'dreamroi',
              medium: 'email',
              campaign: encodeURIComponent(payload.fields.name)
            },
            /* moved to variants
            subjects: [],
            templateSpecs: specs,
            templateSpecsNew: {...specs},
            templateSpecsCategories: [],
            textVersion: true
            */
            templateSpecs: specs, // this is kept here because of the global saleTemplate, originalPrice template specs
          }, payload.fields);
          var r = await API.graphql(graphqlOperation(`
            mutation CreateCampaign(
              $input: CreateCampaignInput!
              $condition: ModelCampaignConditionInput
            ) {
              createCampaign(input: $input, condition: $condition) {
                id
              }
            }
          `, { input }));
          // creating the first variant
          let vinput = {
            active: false,
            name: 'A',
            campaignID: r.data.createCampaign.id,
            //owner: payload.domain.owner, 
            editors: [payload.domain.owner, ...(payload.domain.editors || [])],
            templateSpecs: specs,
            templateSpecsNew: {...specs},
            templateSpecsCategories: [],
          };
          await API.graphql(graphqlOperation(`
            mutation CreateCampaignVariant(
              $input: CreateCampaignVariantInput!
              $condition: ModelCampaignVariantConditionInput
            ) {
              createCampaignVariant(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: vinput }));  

          await context.dispatch('list', { domainID: payload.domain.id });
          return r.data.createCampaign;
        },

        async remove(context, payload) {
          let cr = context.state.list.find(c => c.id == payload.id);
          if(!cr.subjects?.length > 0) {
            // we have variants, delete them
            let variants = await API.graphql(graphqlOperation( /* GraphQL */`
            query GetCampaign($id: ID!) {
              getCampaign(id: $id) {
                # campaign variants
                variants(limit: 1000) {
                  items {
                      id
                  }
                }
              }
            }
            `, { id: payload.id }));
            await Promise.all(variants.data.getCampaign.variants.items.map(v => API.graphql(graphqlOperation(`
            mutation DeleteCampaignVariant(
              $input: DeleteCampaignVariantInput!
              $condition: ModelCampaignVariantConditionInput
            ) {
              deleteCampaignVariant(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: { id: v.id } }))));
          }
          let r = await API.graphql(graphqlOperation(`
            mutation DeleteCampaign(
              $input: DeleteCampaignInput!
              $condition: ModelCampaignConditionInput
            ) {
              deleteCampaign(input: $input, condition: $condition) {
                id
                domainID
              }
            }
          `, { input: { id: payload.id } }));
          
          if(cr.scheduleType == 'AUTOMATIC' && cr.state == 'SENDING') {
            context.dispatch('updateDomain', { id: payload.id, domainID: r.data.updateCampaign.domainID });
          }
          await context.dispatch('list', { domainID: r.data.deleteCampaign.domainID });
        },

        async updateFields(context, payload) {
          let f = payload.fields;
          prepareCampaignForSave(f);
          let r = await API.graphql(graphqlOperation(`
            mutation UpdateCampaign(
              $input: UpdateCampaignInput!
              $condition: ModelCampaignConditionInput
            ) {
              updateCampaign(input: $input, condition: $condition) {
                id
                domainID
              }
            }
          `, { input: Object.assign({ id: context.state.item.id }, f )}));
          // update domain - campaignsUpdated if automatic
          if (f.state != context.state.item.state) {
            context.dispatch('updateDomain', { domainID: r.data.updateCampaign.domainID });
            await context.dispatch('list', { domainID: r.data.updateCampaign.domainID });
          }
          return context.dispatch('get', { id: context.state.item.id });
          //return r.data.updateDomain;
        },
        
        async updateCampaign(context, payload) {
          let r = await API.graphql(graphqlOperation(`
            mutation UpdateCampaign(
              $input: UpdateCampaignInput!
              $condition: ModelCampaignConditionInput
            ) {
              updateCampaign(input: $input, condition: $condition) {
                id
                domainID
              }
            }
          `, { input: payload }));
          // update domain - campaignsUpdated
          let cr = context.state.list.find(c => c.id == payload.id);
          if(cr.scheduleType == 'AUTOMATIC' && (payload.state || cr.state == 'SENDING')) {
            context.dispatch('updateDomain', { id: payload.id, domainID: r.data.updateCampaign.domainID });
          }
          await context.dispatch('list', { domainID: r.data.updateCampaign.domainID, sortDirection: 'DESC' });
        },

        async duplicate(context, payload) {
          let index = context.state.list.findIndex(c => c.id == payload.id);
          let priority = 0;
          let campaign = await context.dispatch('get', {id: context.state.list[index].id, noState: true}); 
          let variants = campaign.variants;
          let editors = [payload.domain.owner, ...(payload.domain.editors || [])];
          if(campaign.scheduleType == 'AUTOMATIC') {
            let upperPriority = context.state.list[index].priority;
            let lowerPriority = context.state.list[index+1]?.priority || 0;
            priority = Math.ceil((upperPriority + lowerPriority) / 2);
          }
          let name = `${campaign.name} (${payload.localizedTitle || 'Copy'})`;
          let fieldsOverride = {
            name, 
            priority,
            state: 'INCOMPLETE',
            editors,
            /*
            templateSpecs: {
              recommendationsCount: 0,
              name: false,
              price: false,
              image: false,
              sale: false,
              description: false,
              originalPrice: false,
              defaultSale: campaign.templateSpecs.defaultSale || 0,
              saleTemplate: campaign.templateSpecs.saleTemplate || '-{}%',
              originalPriceTemplate: campaign.templateSpecs.originalPriceTemplate || '{}',
              stripDescription: campaign.templateSpecs.stripDescription || 0
            },
            */
          };
          console.debug('fieldsOverride', fieldsOverride);
          Object.assign(campaign, fieldsOverride);
          delete(campaign.id);
          delete(campaign.domain);
          delete(campaign.templateSES);
          delete(campaign.createdAt);
          delete(campaign.schedule);
          delete(campaign.variants);
          prepareCampaignForSave(campaign);
          var r = await API.graphql(graphqlOperation(`
            mutation CreateCampaign(
              $input: CreateCampaignInput!
              $condition: ModelCampaignConditionInput
            ) {
              createCampaign(input: $input, condition: $condition) {
                id
                domainID
              }
            }
          `, { input: campaign }));
          // copy campaign variants
          if(variants) {
            // create SES templates? or force users to go through all the variants? that's probably easier
            await Promise.all(
            variants.map(v => (async () => {
              // get each variant id and obtain additional attributes - templateUnlayer
              let templates = await API.graphql(graphqlOperation( /* GraphQL */`
              query GetCampaignVariant($id: ID!) {
                getCampaignVariant(id: $id) {   
                  templateUnlayer
                  templateSES
                  templatePreview
                }
              }
              `, { id: v.id }));
              v = {...v, ...templates.data.getCampaignVariant, /*active: false, */ campaignID: r.data.createCampaign.id, editors };
              delete(v.id);
              if(v.templatePreview && !v.templateSES) {
                v.templateSES = v.templatePreview;
              }
              delete(v.templatePreview);
              await API.graphql(graphqlOperation(`
              mutation CreateCampaignVariant(
                $input: CreateCampaignVariantInput!
                $condition: ModelCampaignVariantConditionInput
              ) {
                createCampaignVariant(input: $input, condition: $condition) {
                  id
                }
              }
              `, { input: v }));
            })()
            ));
            

          }
          await context.dispatch('list', { domainID: r.data.createCampaign.domainID });
          return r.data.createCampaign;
        },

        async updateDomain(context,payload) {

          await API.graphql(graphqlOperation(`
            mutation UpdateDomain(
              $input: UpdateDomainInput!
              $condition: ModelDomainConditionInput
            ) {
              updateDomain(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: { id: payload.domainID, campaignsUpdated: new Date() } }));
        },

        async uploadAsset(context, payload) {
            var result = await Storage.put(`campaigns/${payload.campaign}/${payload.name}`, payload.file, {
                level: 'public',
                // HOWTO: https://github.com/aws-amplify/amplify-js/issues/960
                acl: 'public-read',
                contentType: payload.mime,
                // cache for a week
                cacheControl: 'public, max-age=15768000'
            });
            console.debug(result);
            /*
            return {
                data: [
                    require('@/assets/product-image-placeholder.svg')
                ]
            }
            */
           //return `${result.key}`
           var url = await Storage.get(result.key);
           return url.substr(0, url.indexOf('?'));
        },
        async sendTestEmail(context, payload) {
          let r = await API.graphql(graphqlOperation(`
          mutation SendTestEmail($input: TestEmailInput!) {
            sendTestEmail(input: $input)
          }
          `, { input: payload }));
          return r.data.sendTestEmail;
        },

        async loadRecipients(context) {
          const q = await API.graphql(graphqlOperation(`
            query GetCampaign($id: ID!) {
              getCampaign(id: $id) {
                expectedRecipients
              }
            }
            `, { id: context.state.item.id }));
            let c = q.data.getCampaign;
            context.commit('loadRecipients', c);
        },

        async existingDesigns(context, payload) {
          // TODO add medium - email
          const c = await API.graphql(graphqlOperation(`
          query ExistingDesigns(
            $nextToken: String
          ) {
            listCampaigns(
              filter: {not: {and: {templatePreview: {attributeType: _null}, templateSES: {attributeType: _null}}}}
              nextToken: $nextToken
            ) {
              items {
                id
                name
                domain {
                  name
                }
                state
                scheduleType
                templateSES
                templatePreview
                templateUnlayer
              }
              nextToken
            }
          }
          `, payload ));
          let campaigns = c.data.listCampaigns.items;
          campaigns.filter(c => !!c).forEach(c => { c.templateUnlayer = JSON.parse(c.templateUnlayer); c.preview = getPreview(c.templateSES || c.templatePreview); delete(c.templateSES); delete(c.templatePreview) });
          context.commit('existingDesigns', {value: campaigns.filter(c => !!c.preview), append: !!payload.nextToken });
          if(c.data.listCampaigns.nextToken) {
            await context.dispatch('existingDesigns', { nextToken: c.data.listCampaigns.nextToken });
          }
        },

        /*
        async getUnlayerPreview(context, payload) {
        
          let mt = {};
          Object.values(unlayer.mergeTags).forEach(v => mt[v.value] = v.sample);
  
          // TODO move to backend so API key is not available in source code (custom mutation or sestemplatehandler - but there is a need to provide merge tags, co custom mutation is probably better)
          const options = {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + btoa(`xPXplkWPdWrpA12YditslGqTsxZLtRbwb1kpNgxhhA3Igfx6pAK3f5WN0G3GvxfN:`)},
            body: JSON.stringify({
              displayMode: 'email',
              design: payload.template,
              mergeTags: mt
            })
          };
          
          let response = await (await fetch('https://api.unlayer.com/v2/export/image', options)).json();
          console.debug('preview response', response);
          let url = response.data.url;

        },
        */
        async getStats(context, payload) {
          if(payload.allowCache) {
            if(context.state.statsCache[payload.id]?.updated.valueOf() > (Date.now() - 60 * 60 * 1000)) {
              context.commit('itemStats', context.state.statsCache[payload.id]);
              return context.state.statsCache[payload.id];
            }
          }
          
          let from = null;
          if(payload.period && payload.period != 'all') {
            
            let unit = payload.period[payload.period.length - 1];
            let amount = parseInt(payload.period.substring(0,payload.period.length - 1));
            //console.debug(`Has period ${payload.period} unit ${unit} amount ${amount}`);
            from = new Date();
            if(unit == 'd') {
              from.setDate(from.getDate() - (amount - 1));
            }
            if(unit == 'm') {
              from.setMonth(from.getMonth() - amount);
            }
            from.setHours(0,0,0,0);
          }
          console.debug(`Loading campaign stats from: ${from}`);
          //return;
          const q = await API.graphql(graphqlOperation(`
            query GetCampaign($id: ID!, $from: AWSDateTime) {
              getCampaign(id: $id) {
                stats(from: $from) {
                  globalRates {
                    clicked
                    opened
                    sent
                  }
                  heatmap {
                    friday
                    monday
                    saturday
                    sunday
                    thursday
                    tuesday
                    wednesday
                  }
                  globalSales {
                    sales
                    orders
                  }
                  daySales {
                    sales
                    orders
                    category
                  }
                  subjectRates {
                    clicked
                    opened
                    sent
                    category
                  }
                  variantRates {
                    clicked
                    opened
                    sent
                    category
                  }
                  dayRates {
                    clicked
                    opened
                    sent
                    category
                  }
                  unsubscribes
                }
              }
            }
            `, { id: payload.id, from: from }));
            let stats = { id: payload.id, data: q.data.getCampaign.stats, updated: new Date() };
            if(!payload.noStore) {
              context.commit('statsCache', stats);
              context.commit('itemStats', stats);
            }
            return stats;
        }
    }
}